import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpCancelService } from '@core/services/http-cancel.service';
import { MessageService } from 'primeng/api';
import { catchError, takeUntil, throwError } from 'rxjs';
import { AuthService } from '../../modules/auth/services/auth.service';
import { PublicReportSessionStore } from '@core/services/public-report-session-store.service';

export const commonInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const httpCancelService = inject(HttpCancelService);
  const messageService = inject(MessageService);
  const reportSessions = inject(PublicReportSessionStore);

  let clonedReq = req;
  const reportToken = reportSessions.tokenFromUrl(req.url);
  const isPublicReportRequest = Boolean(reportToken);

  // Case 1: Reset password  and Set password APIs → use resetToken
  if (isPublicReportRequest && reportToken) {
    const token = reportSessions.getValid(reportToken);
    if (token) clonedReq = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  } else if (!req.url.includes('/auth/reset-password') && !req.url.includes('/auth/set-password')) {
    const token = authService.getToken();
    if (token) {
      clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  }

  return next(clonedReq).pipe(
    takeUntil(httpCancelService.onCancelPendingRequests()),
    catchError((err) => {
      if (isPublicReportRequest && reportToken && err.status === 401) {
        reportSessions.invalidate(reportToken);
        return throwError(() => err);
      }

      messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err?.error?.error?.message || err.error.message || err.message,
      });

      if (!isPublicReportRequest && !req.url.includes('login') && [401, 403].includes(err.status)) {
        httpCancelService.cancelPendingRequests();
        authService.logOut();
      }

      return throwError(() => err);
    }),
  );
};
